module.exports = __webpack_public_path__ + "static/media/infoDialogA_background.4aeae5f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/infoDialogA/static/infoDialogA_background.png
// module id = 349
// module chunks = 0